export const createSparkline = ({ color = 'var(--color-primary)', limit = 50 } = {}) => {
  const container = document.createElement('div');
  container.className = 'cm-sparkline';
  
  const canvas = document.createElement('canvas');
  container.appendChild(canvas);
  
  const ctx = canvas.getContext('2d');
  let data = [];

  const resolveColor = (input) => {
    if (!input) return '#00ff9d';
    const trimmed = String(input).trim();
    if (trimmed.startsWith('var(')) {
      const varName = trimmed.slice(4, -1).trim();
      const value = getComputedStyle(container).getPropertyValue(varName).trim();
      return value || trimmed;
    }
    return trimmed;
  };
  
  const resize = () => {
    const rect = container.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    canvas.style.width = `${rect.width}px`;
    canvas.style.height = `${rect.height}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  
  const addData = (val) => {
    data.push(val);
    if (data.length > limit) data.shift();
    draw();
  };
  
  const draw = () => {
    const rect = container.getBoundingClientRect();
    const w = rect.width;
    const h = rect.height;
    
    if (w === 0 || h === 0) return;

    ctx.clearRect(0, 0, w, h);
    if (data.length < 2) return;
    
    const max = Math.max(...data, 100);
    const min = Math.min(...data, 0);
    const range = Math.max(1, max - min);
    const resolvedColor = resolveColor(color);
    
    ctx.beginPath();
    ctx.strokeStyle = resolvedColor;
    ctx.lineWidth = 2;
    ctx.lineJoin = 'round';
    
    data.forEach((val, i) => {
      const x = (i / (limit - 1)) * w;
      const y = h - ((val - min) / range) * h;
      if (i === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    });
    
    ctx.stroke();
    
    // Fill area
    ctx.lineTo(w, h);
    ctx.lineTo(0, h);
    ctx.closePath();
    const gradient = ctx.createLinearGradient(0, 0, 0, h);
    gradient.addColorStop(0, resolvedColor);
    gradient.addColorStop(1, 'transparent');
    ctx.fillStyle = gradient;
    ctx.globalAlpha = 0.25;
    ctx.fill();
    ctx.globalAlpha = 1;
  };
  
  // Observe resize
  const observer = new ResizeObserver(resize);
  observer.observe(container);
  resize();
  
  container.addData = addData;
  return container;
};
